import { render } from "./ToggleSlider.vue?vue&type=template&id=3e6420cb"
import script from "./ToggleSlider.vue?vue&type=script&lang=js"
export * from "./ToggleSlider.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__